import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ticketList: [],
  isTicketLoading: true,
  closedCount: 0,
  closedPercentage: 0,
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    setTicketData(state, action) {
      state.ticketList = action.payload;
      state.isTicketLoading = false;

      const closedCount = state.ticketList.filter(
        (t) => t.status === "closed",
      ).length;

      state.closedCount = closedCount;
      state.closedPercentage = state.ticketList.length
        ? Number(((closedCount / state.ticketList.length) * 100).toFixed(1))
        : 0;
    },

    removeTicketData(state) {
      state.ticketList = [];
      state.isTicketLoading = true;
      state.closedCount = 0;
      state.closedPercentage = 0;
    },
  },
});
export const { setTicketData, removeTicketData } = ticketSlice.actions;
export default ticketSlice.reducer;
